export class WorkspaceApprovalRejectionDetails
   {
      isVisibleForMe :boolean

       approvedDate :Date

       approvalStatus:string

       roleNameForWorkspace:string
   }